import React from "react";
import _ from "underscore";
import PropTypes from "prop-types";
import { Button, PlainButton } from "@evertrue/et-components";
import { CDCNoteContext } from "../contexts/cdc-provider";
import CDCDependenciesContext from "../contexts/cdc-dependencies-context";

const DEFAULT_PLACEHOLDER_COPY =
  "Add a note to explain the reason for your suggestion to your organization's data manager";
const VMS_APP_PLACEHOLDER_COPY =
  "How did you find out about the new contact information? (business card, over the phone, email signature, etc.)";

const CDCModalInfo = props => {
  const { noteInfo, onNoteChange } = React.useContext(CDCNoteContext);
  const { isVMSApp } = React.useContext(CDCDependenciesContext);

  return (
    <div className="cdc-controller--info">
      <label>Info*</label>
      <textarea
        disabled={props.isDisabled}
        placeholder={isVMSApp ? VMS_APP_PLACEHOLDER_COPY : DEFAULT_PLACEHOLDER_COPY}
        value={noteInfo}
        onChange={event => {
          onNoteChange(event.currentTarget.value);
        }}
      />
      {props.type !== "misc" ? (
        <PlainButton className="cdc-controller--info-cancel" onClick={props.onCancel}>
          Cancel {props.panelStatus}
        </PlainButton>
      ) : null}

      <Button
        type="action"
        fixed
        disabled={props.isDisabled || noteInfo === ""}
        onClick={() => {
          props.onSubmit(noteInfo);
        }}
      >
        Save
      </Button>
    </div>
  );
};
CDCModalInfo.propTypes = {
  isDisabled: PropTypes.bool,
  type: PropTypes.oneOf(["phone", "email", "address", "misc"]),
  panelStatus: PropTypes.oneOf(["view", "edit", "retire", "new"]),
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
};

CDCModalInfo.defaultProps = {
  isDisabled: true,
  onCancel: _.noop,
  onSubmit: _.noop,
};

export default CDCModalInfo;
